import { inject, Injectable } from '@angular/core';
import { ActivityInterface } from '@sport-activities/sdk';
import { CanActivateFn, Router } from '@angular/router';
import { ErrorCodesEnum } from '~/core/services/error-code/enums/codes.enum';
import { NavigationService } from '~/core/services/navigation/navigation.service';
import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';
import { organizerSharedGuardActivityMandatoryFieldsToggle } from '~/toggles/default-values/organizer/shared/guards/activity/mandatory-fields';
import { ToggleService } from '~/toggles/services/toggle.service';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  protected readonly errorCode =
    ErrorCodesEnum.OrganizerSharedActivityMandatoryFields;
  protected readonly invalidRedirectionName =
    'organizer.activity-creation.type';
  protected readonly toggleVariantDefaultValue =
    organizerSharedGuardActivityMandatoryFieldsToggle;
  protected readonly toggleVariantName =
    ToggleNameEnum.OrganizerSharedGuardActivityMandatoryFields;

  constructor(
    private readonly activityService: OrganizerSharedActivityService,
    protected readonly navigationService: NavigationService,
    protected readonly router: Router,
    protected readonly toggleService: ToggleService
  ) {}

  public canActivate(): true {
    return true;
  }

  protected getEntity(): ActivityInterface {
    return this.activityService.activity;
  }
}

export const OrganizerSharedActivityMandatoryFieldsGuard: CanActivateFn =
  (): true => {
    return inject(PermissionsService).canActivate();
  };
